/**
 * Interface pro avatar
 */
export interface IUserProfileData {
    [key: string]: string;
}

/**
 * Interface pro nahrátí nových dat
 */
export interface IUserProfileDataNewData extends IUserProfileData {
    new: string;
}
